<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		methods: {
			valid_email: function () {
				let value = this.data.value;
				let params = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
				let valid = params.test(value);
				if(!valid) {
					this.data.error = true;
				}
				else {
					this.data.error = false;
				}
			},
		},
	}
</script>

<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>
		<input
			type="text"
			maxlength="50"
			autocomplete="off"
			v-model.trim="data.value"
			@input="valid_email"
			:class="{'is-invalid': data.error  && errorForm }"
			class="form-control input-custom"
			placeholder="Ingresa un correo"
		/>
		<div class="invalid-feedback">
			Debes agregar un correo válido.
		</div>
	</div>
</template>